import React, { useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { useNavigate } from "react-router-dom";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import { useDispatch, useSelector } from "react-redux";
import { listLaneMasterAsync } from "../../../../redux/features/laneMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { BsPencilSquare } from "react-icons/bs";
import toast from "react-hot-toast";
import { changeStatus } from "../../../../Api/dispatch/lane-dispatch";
import * as XLSX from "xlsx";
import moment from "moment/moment";
import { useBoolean } from "../../../../Hooks/useBoolean";
import DownloadReportButton from "../../../../components/common/DownloadReportButton";
import { laneMasterReportAsync } from "../../../../redux/features/reportSlice";

export default function LaneMasterList() {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const laneMaster = useSelector((state) => state.laneMaster);
   const laneMasterData = laneMaster?.dataList;

   const [records, setRecords] = useState();
   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });

   const reportPopup = useBoolean();

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         listLaneMasterAsync({
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
         }),
      );
   }, [dispatch]);

   useEffect(() => {
      setRecords(laneMasterData);
   }, [laneMasterData]);

   // Handle active inactive
   /************  Pending for api endpoint****************/
   const handleActiveInactive = (lane) => {
      setIsActiveLoading({ id: lane?.id, status: true });
      changeStatus({ id: lane?.id, status: lane?.is_active === "1" ? "0" : "1" })
         .then((res) => {
            setIsActiveLoading({ id: lane?.id, status: false });
            dispatch(listLaneMasterAsync({}));
            toast.success(
               `lane ${lane?.is_active === "1" ? "deactivated" : "activated"}`,
            );
         })
         .catch((error) => {
            setIsActiveLoading({ id: lane?.id, status: false });
            //toast.error(
            //    `Failed to ${lane?.is_active === "1" ? "deactivate" : "activate"} lane`,
            // );
         });
   };

   //  Download fleet Report
   const handleDownloadReport = (data) => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         laneMasterReportAsync({
            data: data,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (report) => {
               const headers = [
                  "S. No.",
                  "Lane Name",
                  "Vendor Name",
                  "Origin",
                  "Destination",
                  "Driver Trip Advance",
                  "Trip Diesel budget (ltr)",
                  "Trip Adblue budget (ltr)",
                  "Trip Toll",
                  "Vehicle Type",
                  "Tonnage",
                  "Customer Name (Including broker)",
                  "TAT (in Hrs)",
               ];

               const laneMasterDataArr = [];
               const adhocLaneMasterDataArr = [];

               report?.laneMaster?.forEach?.((item, index) => {
                  const arr = [];
                  arr.push(
                     index + 1, // S. No.
                     item?.name ?? "-", // Lane Name
                     item?.vendor_master?.name ?? "-", // Vendor Name
                     item?.origin_location_master?.name ?? "-", // Origin
                     item?.destination_location_master?.name ?? "-", // Destination
                     item?.driver_trip_advance ?? "-", // Driver Trip Advance
                     item?.tripdiesel_budget ?? "-", // Trip Diesel budget (ltr)
                     item?.trip_adblue_budget ?? "-", // Trip Adblue budget (ltr)
                     item?.trip_toll ?? "-", // Trip Toll
                     item?.vehicle_type ?? "-", // Vehicle Type
                     item?.tonnage?.tonnage ?? "-", // Tonnage
                     item?.customer_master?.name ?? "-", // Customer Name (Including broker)
                     item?.tat ?? "-", // TAT (in Hrs)
                  );
                  laneMasterDataArr.push(arr);
               });

               report?.adhocLaneMaster?.forEach?.((item, index) => {
                  const arr = [];
                  arr.push(
                     report?.laneMaster?.length + index + 1, // S. No.
                     item?.name ?? "-", // Lane Name
                     item?.vendor_master?.name ?? "-", // Vendor Name
                     item?.origin_location_master?.name ?? "-", // Origin
                     item?.destination_location_master?.name ?? "-", // Destination
                     item?.driver_trip_advance ?? "-", // Driver Trip Advance
                     item?.tripdiesel_budget ?? "-", // Trip Diesel budget (ltr)
                     item?.trip_adblue_budget ?? "-", // Trip Adblue budget (ltr)
                     item?.trip_toll ?? "-", // Trip Toll
                     item?.vehicle_type ?? "-", // Vehicle Type
                     item?.tonnage?.tonnage ?? "-", // Tonnage
                     item?.customer_master?.name ?? "-", // Customer Name (Including broker)
                     item?.tat ?? "-", // TAT (in Hrs)
                  );
                  adhocLaneMasterDataArr.push(arr);
               });

               // Combine headers and rows
               const sheetData = [
                  headers,
                  ...laneMasterDataArr,
                  ...adhocLaneMasterDataArr,
               ];

               const ws = XLSX.utils.aoa_to_sheet(sheetData);

               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "LANE_MASTER_REPORT.xlsx");
               dispatch(backdropLoadingAction(false));
               reportPopup.onFalse();
            },
         }),
      );
   };

   const columns = [
      {
         name: "Lane Name",
         selector: (row) => row?.lane_master?.name,
         sortable: true,
      },
      {
         name: "Vendor Name",
         selector: (row) => row?.vendor_master?.name,
      },

      {
         name: "Customer Name",
         selector: (row) => row?.lane_master?.customer_master?.name,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button
                     className="btn"
                     onClick={() => navigate(`/lane-master/edit/${row?.id}`)}
                  >
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>
                  <CustomToggleSwitch
                     checked={row?.is_active === "1"}
                     onChange={() => handleActiveInactive(row)}
                     isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
                  />
               </div>
            );
         },
      },
   ];

   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();
      const filterData = laneMasterData?.filter?.((item) => {
         return (
            item?.lane_master?.name?.toLowerCase().includes(searchText) ||
            item?.vendor_master?.name?.toLowerCase().includes(searchText) ||
            item?.lane_master?.customer_master?.name?.toLowerCase().includes(searchText)
         );
      });
      setRecords(filterData);
   };

   return (
      <div>
         <BodyHeader title="Lane Master List" />

         <div className="px-3">
            <div className=" d-flex justify-content-between">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />

               <DownloadReportButton
                  onDownloadReport={handleDownloadReport}
                  confirmPopup={reportPopup}
               />
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
